module.exports = __webpack_public_path__ + "static/header-834e1170ce55d68ac32641859f45579d.jpg";